export default function($) {
  var originalWindowWidth = $(window).width();

  $('.js-radio-deselect').on('click', function(event) {
    var $form = $(this).closest('form'),
        previouslyChecked = $(this).data('previously-checked');

    if (previouslyChecked) {
      $(this).prop('checked', false);
      $(this).data('previously-checked', false);
    } else {
      $form.find('.js-radio-deselect').data('previously-checked', false);
      $(this).data('previously-checked', true);
    }
    $form.submit();
  });

  $('.js-radio-deselect').each(function() {
    if ($(this).is(':checked')) {
      $(this).data('previously-checked', true);
    }
  });

  $('.js-structure-radio-deselect').on('click', function() {
    var resetLink = $(this).closest('form').find('.js-reset-structure-radio').attr('href');
    window.location.href = resetLink;
  })

  function toggleSidebar($elem) {
    $elem.toggleClass('open')
  }

  function openSidebar($elem) {
    $elem.css('width', '90%')
    $elem.css('padding', '1rem')
    $('body').addClass('overflow-hidden')
  }

  function closeSidebar($elem) {
    $elem.css('width', '0')
    $elem.css('padding', '0')
    $elem.removeClass('open')
    $('body').removeClass('overflow-hidden')
  }

  function resetDesktopSidebar($elem) {
    $elem.css('width', '100%')
    $elem.addClass('open')
    $('body').removeClass('overflow-hidden')
  }

  function resetMobileSidebar($elem) {
    $elem.css('width', '0')
    $elem.css('padding', '0')
    $elem.removeClass('open')
  }

  $('#toggle-filters').on('click', function() {
    toggleSidebar($('#filter-sidebar'))
    openSidebar($('#filter-sidebar'))
  })

  $('#close-filters').on('click', function() {
    closeSidebar($('#filter-sidebar'))
  })

  $(document).on('click', function(e) {
    if( $(window).outerWidth() < 1024 ) {
      if ($('#filter-sidebar').hasClass('open') && !$(e.target).closest('#filter-sidebar, #toggle-filters').length) {
        closeSidebar($('#filter-sidebar'))
      }
    }
  });

  $(window).resize(function() {
    if( $(window).outerWidth() >= 1024 ) {
      resetDesktopSidebar($('#filter-sidebar'))
    } else {
      if( $(window).width() != originalWindowWidth) {
        resetMobileSidebar($('#filter-sidebar'))
      }
    }
  })
}
